<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>

      <el-select v-model="listQuery.goods_type_id" placeholder="商品类型" filterable class="filter-item" style="width: 200px" clearable>
        <el-option v-for="item in mallGoodsTypes" :key="item.id" :label="item.name" :value="item.id">
          <div>{{ item.name }} <span style="font-size: 12px;color:red;">({{ item.is_on === 1 ? "正常" : "已下架" }})</span></div>
        </el-option>
      </el-select>

      <el-input v-model="listQuery.name" placeholder="名称" class="filter-item" style="width: 200px;" clearable />

      <el-select v-model="listQuery.is_on" placeholder="状态" style="width: 120px" class="filter-item" clearable>
        <el-option label="下架" :value="0"/>
        <el-option label="正常" :value="1"/>
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="商品类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.goods_type.name }}
        </template>
      </el-table-column>

      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="封面" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover" class="user-avatar">
        </template>
      </el-table-column>

      <el-table-column label="参考价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.reference_price }}
        </template>
      </el-table-column>

      <el-table-column label="参考积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.reference_points }}
        </template>
      </el-table-column>

      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on === 1" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_on === 0" type="danger">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="商品类型" prop="goods_type_id">
          <el-select v-model="form.goods_type_id">
            <el-option v-for="item in mallGoodsTypes" :key="item.id" :label="item.name" :value="item.id">
              <div>{{ item.name }} <span style="font-size: 12px;color:red;">({{ item.is_on === 1 ? "正常" : "已下架" }})</span></div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="封面" prop="cover">
          <upload-one v-model="form.cover"></upload-one>
          <div style="font-size:12px;color:red;">*推荐尺寸：120*120</div>
        </el-form-item>

        <el-form-item label="参考价格" prop="reference_price">
          <el-input-number v-model="form.reference_price" :min="0" :precision="2" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="参考积分" prop="reference_points">
          <el-input-number v-model="form.reference_points" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="规格" prop="goods_attr_info">
          <el-tag v-for="(item, index) in form.goods_attr" :key="index" closable :disable-transitions="false" @close="handleGoodsAttrClose(item)" style="margin-right: 10px;">
            {{ item.name }}
          </el-tag>

          <el-button size="small" @click="handleGoodsAttrAdd()">添加</el-button>

          <el-table v-if="form.goods_attr_info.length" :data="form.goods_attr_info" border fit style="margin-top: 15px">
            <el-table-column label="sku组合" min-width="110" align="center">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>

            <el-table-column label="封面" min-width="110" align="center">
              <template slot-scope="scope">
                <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
                  <upload-one v-model="scope.row.cover"></upload-one>
                  <div style="font-size:12px;color:red;">*推荐尺寸：120*120</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="价格" min-width="110" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.price" :min="0" :precision="2" controls-position="right" style="width: 100%;max-width: 220px;"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="积分" min-width="110" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.points" :min="0" :precision="0" controls-position="right" style="width: 100%;max-width: 220px;"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="库存" min-width="110" align="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.stock" :min="0" :precision="0" controls-position="right" style="width: 100%;max-width: 220px;"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="轮播图" prop="pictures">
          <upload-list v-model="form.pictures"></upload-list>
          <div style="font-size:12px;color:red;">*推荐尺寸：750*750</div>
        </el-form-item>

        <el-form-item label="商品渠道信息" prop="goods_channel_info">
          <el-button icon="el-icon-plus" size="mini" plain @click="handelGoodsChannelInfoAdd"></el-button>

          <el-table :data="form.goods_channel_info" border fit>
            <el-table-column label="商品渠道" min-width="110" align="center">
              <template slot-scope="scope">
                <el-select v-model="scope.row.goods_channel_id">
                  <el-option v-for="item in mallGoodsChannels" :key="item.id" :label="item.name" :value="item.id">
                    <div style="display: flex;align-items:center;text-align:center;">
                      <img :src="item.logo" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
                      <span>{{ item.name }}</span>
                    </div>
                  </el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="跳转路径" min-width="110" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.path" />
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="110" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handelGoodsChannelInfoDel(scope.$index)">删除</el-button>

                <el-button type="primary" size="mini" @click="handelGoodsChannelInfoUp(scope.$index)">上移</el-button>

                <el-button type="primary" size="mini" @click="handelGoodsChannelInfoDown(scope.$index)">下移</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number v-model="form.weight" :min="1" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*权重越大，排名越前</div>
          </div>
        </el-form-item>

        <el-form-item label="状态" prop="is_on">
          <el-switch v-model="form.is_on" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>

        <el-form-item label="商品介绍" prop="introduction">
          <tinymce ref="tinymce" :height="400" v-model="form.introduction" :value="form.introduction" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->

    <!-- 规格 -->
    <el-dialog :visible.sync="dialogVisibleGoodsAttr" width="50%" :close-on-click-modal="false">
      <el-form ref="goodsAttrForm" :model="goodsAttrForm" label-width="150px">
        <el-form-item label="规格类型">
          <el-select v-model="goodsAttrForm.goods_attr_type_id">
            <el-option v-for="(item, index) in mallGoodsAttrTypes" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="规格名称">
          <el-tag v-for="(item, index) in goodsAttrForm.goods_attr_names" :key="index" closable :disable-transitions="false" @close="handleGoodsAttrNameClose(item)" style="margin-right: 10px;">
            {{ item }}
          </el-tag>

          <el-input v-if="goodsAttrForm.goods_attr_name_visible" v-model="goodsAttrForm.goods_attr_name_value" ref="saveTagInput" size="small" @keyup.enter.native="handleGoodsAttrNameConfirm" @blur="handleGoodsAttrNameConfirm" style="width: 150px;vertical-align: bottom;">
          </el-input>
          <el-button v-else size="small" @click="handleGoodsAttrNameAdd">添加</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleGoodsAttr = false">取消</el-button>
        <el-button type="primary" @click="saveDataGoodsAttr" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 规格 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import Tinymce from "@/components/Tinymce";
  import { descartes } from "@/utils/tool";

  export default {
    components: { Tinymce },
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          goods_type_id: "",
          name: "",
          is_on: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          goods_type_id: "",
          name: "",
          cover: "",
          reference_price: 0,
          reference_points: 0,
          pictures: [],
          introduction: "",
          weight: 1,
          is_on: 1,
          goods_channel_info: [],
          goods_attr: [],
          goods_attr_info: [],
        },
        rules: {
          goods_type_id: [{ required: true, message: "商品类型不能为空", trigger: "change" }],
          name: [{ required: true, message: "名称不能为空", trigger: "change" }],
          cover: [{ required: true, message: "封面不能为空", trigger: "change" }],
          reference_price: [{ required: true, message: "参考价格不能为空", trigger: "change" }],
          reference_points: [{ required: true, message: "参考积分不能为空", trigger: "change" }],
          pictures: [{ required: true, message: "轮播图不能为空", trigger: "change" }],
          weight: [{ required: true, message: "权重不能为空", trigger: "change" }],
          is_on: [{ required: true, message: "状态不能为空", trigger: "change" }],
        },
        mallGoodsTypes: [],
        mallGoodsChannels: [],
        mallGoodsAttrTypes: [],
        dialogVisibleGoodsAttr: false,
        goodsAttrForm: {
          goods_attr_type_id: "",
          goods_attr_names: [],
          goods_attr_name_value: "",
          goods_attr_name_visible: false,
        },
      };
    },
    created() {
      this.getList();
      this.getMallGoodsTypeList();
      this.getMallGoodsChannelList();
      this.getMallGoodsAttrTypeList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/mallGoods/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getMallGoodsTypeList() {
        request({
          url: "/api/backend/mallGoodsType/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
          }
        }).then(response => {
          this.mallGoodsTypes = response.data.data;
        });
      },
      getMallGoodsChannelList() {
        request({
          url: "/api/backend/mallGoodsChannel/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            is_on: 1,
          }
        }).then(response => {
          this.mallGoodsChannels = response.data.data;
        });
      },
      getMallGoodsAttrTypeList() {
        request({
          url: "/api/backend/mallGoodsAttrType/list",
          method: "get",
          params: {}
        }).then(response => {
          this.mallGoodsAttrTypes = response.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          goods_type_id: "",
          name: "",
          cover: "",
          reference_price: 0,
          reference_points: 0,
          pictures: [],
          introduction: "",
          weight: 1,
          is_on: 1,
          goods_channel_info: [],
          goods_attr: [],
          goods_attr_info: [],
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        if(this.$refs.tinymce) this.$refs.tinymce.setContent("")
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        // this.form = Object.assign({}, row)
        this.form = JSON.parse(JSON.stringify(row))
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        if(this.$refs.tinymce) this.$refs.tinymce.setContent(row.introduction||"")
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        for (let index = 0; index < this.form.goods_channel_info.length; index++) {
          const element = this.form.goods_channel_info[index];

          if (element.goods_channel_id === "") {
            this.$message({
              type: "warning",
              message: "商品渠道信息的商品渠道不能为空",
            });
            return;
          }

          if (element.path === "") {
            this.$message({
              type: "warning",
              message: "商品渠道信息的跳转路径不能为空",
            });
            return;
          }
        }

        if (this.form.goods_attr_info.length === 0) {
          this.$message({
            type: "warning",
            message: "规格不能为空",
          });
          return;
        }
        for (let index = 0; index < this.form.goods_attr_info.length; index++) {
          const element = this.form.goods_attr_info[index];

          if (element.name === "") {
            this.$message({
              type: "warning",
              message: "规格的sku组合不能为空",
            });
            return;
          }

          if (element.cover === "") {
            this.$message({
              type: "warning",
              message: "规格的封面不能为空",
            });
            return;
          }

          if (element.price === undefined) {
            this.$message({
              type: "warning",
              message: "规格的价格不能为空",
            });
            return;
          }

          if (element.points === undefined) {
            this.$message({
              type: "warning",
              message: "规格的积分不能为空",
            });
            return;
          }

          if (element.stock === undefined) {
            this.$message({
              type: "warning",
              message: "规格的库存不能为空",
            });
            return;
          }
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/mallGoods/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      // 商品渠道信息
      handelGoodsChannelInfoAdd() {
        this.form.goods_channel_info.push({
          id: "",
          goods_channel_id: "",
          path: "",
        });
      },
      handelGoodsChannelInfoDel(index) {
        this.form.goods_channel_info.splice(index, 1);
      },
      handelGoodsChannelInfoUp(index) {
        if (index === 0) {
          return;
        }
        this.form.goods_channel_info.splice(index - 1, 0, this.form.goods_channel_info.splice(index, 1)[0]);
      },
      handelGoodsChannelInfoDown(index) {
        if (index >= this.form.goods_channel_info.length - 1) {
          return;
        }
        this.form.goods_channel_info.splice(index + 1, 0, this.form.goods_channel_info.splice(index, 1)[0]);
      },
      // 规格
      handleGoodsAttrClose(item) {
        this.form.goods_attr.splice(this.form.goods_attr.indexOf(item), 1);
        this.handleSetSKU();
      },
      handleGoodsAttrAdd() {
        this.goodsAttrForm = {
          goods_attr_type_id: "",
          goods_attr_names: [],
          goods_attr_name_value: "",
          goods_attr_name_visible: false,
        }
        this.dialogVisibleGoodsAttr = true;
      },
      handleGoodsAttrNameClose(item) {
        this.goodsAttrForm.goods_attr_names.splice(this.goodsAttrForm.goods_attr_names.indexOf(item), 1);
      },
      handleGoodsAttrNameConfirm() {
        let name = this.goodsAttrForm.goods_attr_name_value;
        if (name) {
          this.goodsAttrForm.goods_attr_names.push(name);
        }
        this.goodsAttrForm.goods_attr_name_visible = false;
        this.goodsAttrForm.goods_attr_name_value = "";
      },
      handleGoodsAttrNameAdd() {
        this.goodsAttrForm.goods_attr_name_visible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      saveDataGoodsAttr() {
        if (!this.goodsAttrForm.goods_attr_type_id) {
          this.$message({
            type: "warning",
            message: "规格类型不能为空",
          });
          return;
        }
        if (this.goodsAttrForm.goods_attr_names.length === 0) {
          this.$message({
            type: "warning",
            message: "规格名称不能为空",
          });
          return;
        }
        let goodsAttrArr = [];
        this.goodsAttrForm.goods_attr_names.map(item => {
          let obj = {
            id: "",
            name: item,
            goods_attr_type_id: this.goodsAttrForm.goods_attr_type_id
          };
          goodsAttrArr.push(obj);
        });
        this.form.goods_attr.push(...goodsAttrArr);
        this.form.goods_attr.sort((a, b) => a.goods_attr_type_id - b.goods_attr_type_id);
        this.handleSetSKU();
        this.dialogVisibleGoodsAttr = false;
      },
      handleSetSKU() {
        let arrayTwo = Object.values(
            this.form.goods_attr.reduce((res, item) => {
              res[item.goods_attr_type_id] ? res[item.goods_attr_type_id].push(item.name) : (res[item.goods_attr_type_id] = [item.name]);
              return res;
            }, {})
        );
        let r = descartes(arrayTwo);
        let goodsAttrInfoArr = [];
        r.map(item => {
          let obj = {
            id: "",
            name: item.join(","),
            cover: "",
            price: undefined,
            points: undefined,
            stock: undefined,
          };
          goodsAttrInfoArr.push(obj);
        });
        this.form.goods_attr_info = goodsAttrInfoArr;
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
</style>
